import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactModal from 'react-modal';
import { Button, CircularProgress, FormControlLabel, Grid, InputLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import _ from 'lodash';
import { mobilizeiStoresService } from '../_services/mobilizei/stores.service';

ReactModal.setAppElement('#root')

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(10, 10, 10, 0.45)',
        zIndex: 999
    },
    content: {
        height: 'fit-content',
        width: '35%',
        margin: 'auto'
    }
};

const useStyles = makeStyles(() => ({
    title: {
        marginTop: 0
    },
    helpButton: {
        position: 'absolute',
        top: 12,
        right: 0
    },
    fullWidthShrink: {
        width: '133%'
    },
    statusTooltipContainer: {
        marginBottom: 15,
        marginTop: 5
    }
}))

export default function ConfigurationModal({ data, isOpen, onClose, onDataUpdate, platformId }) {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        isAppExclusive: false,
        generalSettings: {},
        webviewInjectedJavascript: ''
    })

    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (data) {
            setFormData({
                isAppExclusive: !!data.isAppExclusive,
                generalSettings: data.generalSettings ?? {},
                webviewInjectedJavascript: data.webviewInjectedJavascript ?? ' '
            });
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        let newValue;
        if (type === 'checkbox') {
            newValue = checked;
        } else if (value === 'true' || value === 'false') {
            newValue = value === 'true';
        } else {
            newValue = value;
        }

        if (name !== 'isAppExclusive' && name !== 'webviewInjectedJavascript') {
            setFormData(prev => ({
                ...prev,
                generalSettings: {
                    ...prev.generalSettings,
                    [name]: newValue
                }
            }));
            return
        }

        setFormData(prev => ({
            ...prev,
            [name]: newValue,
        }));
    };

    const handleSave = () => {
        setLoading(true);

        const errors = {};
        setErrors({});

        const requiredMsg = "Este campo é obrigatório.";

        if (_.isEmpty(errors)) {
            mobilizeiStoresService.updateStoreById(platformId, data.id, formData)
                .then(() => {
                    onDataUpdate();
                    onClose();
                })
                .catch(() => {
                    alert('Não foi possível atualizar as configurações do aplicativo.')
                })
                .finally(() => setLoading(false))
        } else {
            setLoading(false);
            setErrors(errors);
        }
    }

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={() => onClose()}
            style={customStyles}
        >
            <h2 align="center" className={classes.title}>Configurações do aplicativo</h2>

            <Grid container alignItems="flex-start" spacing={2}>
                <Grid item xs={12}>
                    <InputLabel htmlFor="isAppExclusive" shrink>O aplicativo é Exclusivo?</InputLabel>
                    <RadioGroup
                        aria-label="isAppExclusive"
                        name="isAppExclusive"
                        row
                        value={formData.isAppExclusive ? "true" : "false"}
                        onChange={handleChange}
                    >
                        <FormControlLabel value="true" control={<Radio />} label="Sim" />
                        <FormControlLabel value="false" control={<Radio />} label="Não" />
                    </RadioGroup>
                </Grid>

                {platformId === 'tray' && (
                    <>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="useProductListWebview" shrink>Usar tela de lista de produtos webview?</InputLabel>
                            <RadioGroup
                                aria-label="useProductListWebview"
                                name="useProductListWebview"
                                row
                                value={formData.generalSettings.useProductListWebview ? "true" : "false"}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="true" control={<Radio />} label="Sim" />
                                <FormControlLabel value="false" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel htmlFor="useProductWebview" shrink>Usar tela de produtos webview?</InputLabel>
                            <RadioGroup
                                aria-label="useProductWebview"
                                name="useProductWebview"
                                row
                                value={formData.generalSettings.useProductWebview ? "true" : "false"}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="true" control={<Radio />} label="Sim" />
                                <FormControlLabel value="false" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel htmlFor="useCartWebview" shrink>Usar tela de carrinho webview?</InputLabel>
                            <RadioGroup
                                aria-label="useCartWebview"
                                name="useCartWebview"
                                row
                                value={formData.generalSettings.useCartWebview ? "true" : "false"}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="true" control={<Radio />} label="Sim" />
                                <FormControlLabel value="false" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </Grid>
                    </>
                )}

                {(platformId === 'tray' || platformId === 'nuvemshop') && (
                    <Grid item xs={12}>
                        <InputLabel htmlFor="showPricesOnlyToLoggedUsers" shrink>Exibir preços somente para usuários logados?</InputLabel>
                        <RadioGroup
                            aria-label="showPricesOnlyToLoggedUsers"
                            name="showPricesOnlyToLoggedUsers"
                            row
                            value={formData.generalSettings.showPricesOnlyToLoggedUsers ? "true" : "false"}
                            onChange={handleChange}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="Sim" />
                            <FormControlLabel value="false" control={<Radio />} label="Não" />
                        </RadioGroup>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <InputLabel htmlFor="webviewInjectedJavascript" shrink>Script injetado no webview</InputLabel>
                    <TextField
                        aria-label="webviewInjectedJavascript"
                        name="webviewInjectedJavascript"
                        row
                        value={formData.webviewInjectedJavascript || ''}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>

                <Grid container justify="center" item xs={12}>
                    {loading ? <CircularProgress /> :
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            Salvar
                        </Button>
                    }
                </Grid>

            </Grid>
        </ReactModal>
    )
}